import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { fbPageView } from "@/lib/pixel";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Prima încărcare declanșează deja PageView din index.html.
    // La fiecare navigare ulterioară trimitem PageView, ca să poți urmări
    // fiecare pagină în Meta Pixel. InitiateCheckout (cu valoare) se declanșează
    // direct în pagina Checkout, unde avem valoarea reală a coșului.
    if (first.current) {
      first.current = false;
    } else {
      fbPageView();
    }
  }, [pathname]);

  return null;
};
